import React, { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Loader2 } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await axios.post(`${BACKEND_URL}/api/contact`, formData);
      
      if (response.status === 200) {
        setSubmitted(true);
        setFormData({
          name: '',
          email: '',
          phone: '',
          message: ''
        });
      }
    } catch (err) {
      console.error('Error submitting form:', err);
      setError('Failed to submit. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="contact-form-success">
        <div className="success-icon">✓</div>
        <h3 className="success-title">Thank You!</h3>
        <p className="success-message">
          Your message has been received. We'll get back to you soon.
        </p>
        <Button 
          onClick={() => setSubmitted(false)}
          className="btn-secondary"
          style={{ marginTop: '1rem' }}
        >
          Send Another Message
        </Button>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="contact-form">
      <div className="form-group">
        <Input
          type="text"
          name="name"
          placeholder="Your Name *"
          value={formData.name}
          onChange={handleChange}
          required
          className="form-input"
        />
      </div>
      
      <div className="form-group">
        <Input
          type="email"
          name="email"
          placeholder="Your Email *"
          value={formData.email}
          onChange={handleChange}
          required
          className="form-input"
        />
      </div>
      
      <div className="form-group">
        <Input
          type="tel"
          name="phone"
          placeholder="Phone Number (Optional)"
          value={formData.phone}
          onChange={handleChange}
          className="form-input"
        />
      </div>
      
      <div className="form-group">
        <Textarea
          name="message"
          placeholder="Tell us about your interest in joining the movement *"
          value={formData.message}
          onChange={handleChange}
          required
          className="form-textarea"
          rows={4}
        />
      </div>

      {error && <div className="form-error">{error}</div>}
      
      <Button 
        type="submit" 
        disabled={loading}
        className="btn-primary btn-large"
        style={{ width: '100%' }}
      >
        {loading ? (
          <>
            <Loader2 className="animate-spin" style={{ marginRight: '8px' }} />
            Sending...
          </>
        ) : (
          'Submit'
        )}
      </Button>
    </form>
  );
};
